export default "__VITE_ASSET__BNJdMvcK__"